import { Divider, Grid } from "@material-ui/core";
import React from "react";
import DataCell from "../../cells/data";
import PhoneCell from "../../cells/phone";

const labelsNameMapping = {
  email: {
    one: "E-mail",
    other: "E-mails",
  },
  movel: {
    one: "Telefone móvel",
    other: "Telefones móveis",
  },
  fixo: {
    one: "Telefone fixo",
    other: "Telefones fixos",
  },
};

const ContactData = ({ data }) => {
  const { phones, emails } = data;

  const contacts = {
    email: emails,
    movel: phones?.filter(({ tipo }) => tipo === "movel"),
    fixo: phones?.filter(({ tipo }) => tipo === "fixo"),
  };

  return (emails && emails.length > 0) || (phones && phones.length > 0) ? (
    <>
      <Divider className="mt-20 mb-20 w-100" />

      <Grid spacing={3} container>
        {Object.keys(contacts).map((type) => {
          const list = contacts[type];

          return (
            list?.length > 0 && (
              <Grid sm={6} lg={4} key={type} item>
                <Grid spacing={3} container>
                  <Grid xs={12} className="qd-data-cell-label" item>
                    {
                      labelsNameMapping[type][
                        list.length === 1 ? "one" : "other"
                      ]
                    }
                  </Grid>

                  {list.map((obj, i) => {
                    const value = obj[type === "email" ? "email" : "numero"];

                    return React.createElement(
                      type === "email" ? DataCell : PhoneCell,
                      {
                        value,
                        key: `${type}-${value}`,
                        xs: 12,
                      }
                    );
                  })}
                </Grid>
              </Grid>
            )
          );
        })}
      </Grid>
    </>
  ) : null;
};

export default ContactData;
